import { render, staticRenderFns } from "./SupportStatus.vue?vue&type=template&id=49b354de&"
import script from "./SupportStatus.vue?vue&type=script&lang=js&"
export * from "./SupportStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports